class CartReservationTimer extends HTMLElement {
  connectedCallback() {
    this.durationMs = parseInt(this.dataset.durationMs, 10) || 10 * 60 * 1000;
    this.storageKey = this.dataset.storageKey || 'cart_reservation_timer_end';
    this.timeEl = this.querySelector('[data-cart-reservation-time]');

    this.endTime = this.getOrCreateEndTime();
    this.boundVisibilityChange = this.onVisibilityChange.bind(this);
    this.boundStorageChange = this.onStorageChange.bind(this);

    this.render(this.endTime - Date.now()); // paint immediately, avoid a blank first second
    this.intervalId = setInterval(() => this.tick(), 1000);

    document.addEventListener('visibilitychange', this.boundVisibilityChange);
    window.addEventListener('storage', this.boundStorageChange);
  }

  disconnectedCallback() {
    clearInterval(this.intervalId);
    document.removeEventListener('visibilitychange', this.boundVisibilityChange);
    window.removeEventListener('storage', this.boundStorageChange);
  }

  getOrCreateEndTime() {
    const stored = parseInt(this.readStorage(this.storageKey), 10);
    const now = Date.now();

    if (stored && stored > now) {
      return stored;
    }

    return this.restart();
  }

  restart() {
    const newEnd = Date.now() + this.durationMs;
    this.writeStorage(this.storageKey, String(newEnd));
    return newEnd;
  }

  tick() {
    const remaining = this.endTime - Date.now();

    if (remaining <= 0) {
      this.endTime = this.restart();
      this.render(this.durationMs);
      return;
    }

    this.render(remaining);
  }

  render(remainingMs) {
    const totalSeconds = Math.max(Math.ceil(remainingMs / 1000), 0);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    if (this.timeEl) {
      this.timeEl.textContent = `${minutes}:${String(seconds).padStart(2, '0')}`;
    }

    this.classList.toggle('is-urgent', totalSeconds <= 60);
  }

  onVisibilityChange() {
    // Tabs throttle timers in the background; recheck against the stored end time
    // as soon as the tab is visible again, in case it expired while hidden.
    if (document.visibilityState === 'visible') {
      this.endTime = this.getOrCreateEndTime();
      this.tick();
    }
  }

  onStorageChange(event) {
    // Keeps multiple open tabs (e.g. two windows on the same store) in sync.
    if (event.key === this.storageKey && event.newValue) {
      this.endTime = parseInt(event.newValue, 10);
      this.tick();
    }
  }

  readStorage(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  writeStorage(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      // Private browsing / storage disabled — timer still works, just won't persist across reloads.
    }
  }
}

customElements.define('cart-reservation-timer', CartReservationTimer);